import { ActionIcon, Loader } from '@mantine/core';
import { MouseEventHandler } from 'react';
import { ChevronDown } from 'tabler-icons-react';

type DropdownStates = 'opened' | 'closed' | 'loading' | 'disabled' | 'error';
interface IPickerOpenerProps {
    onClick: MouseEventHandler;
    state: DropdownStates | Partial<Record<DropdownStates, boolean>>;
    size?: 'sm';
}
export function DropdownOpener({ state: stateProp, onClick, size }: IPickerOpenerProps) {
    const state = typeof stateProp !== 'string' ? stateProp : ({ [stateProp]: true } as Record<DropdownStates, boolean | undefined>);
    const { loading, opened, disabled, error } = state;
    const btnSize = size === 'sm' ? 24 : undefined;
    const chevSize = size === 'sm' ? 18 : 20;
    return loading ? (
        <Loader size={16} />
    ) : (
        <ActionIcon
            variant={opened ? 'default' : undefined}
            color={opened ? 'primary' : disabled ? 'gray.5' : error ? 'error.6' : undefined}
            sx={{ flex: '0 0 auto', height: btnSize, width: btnSize, minHeight: btnSize, minWidth: btnSize }}
            tabIndex={-1}
            onClick={onClick}
        >
            <ChevronDown style={{ transition: 'linear .25s', transform: opened ? 'rotateX(180deg)' : undefined }} strokeWidth={3} size={chevSize} />
        </ActionIcon>
    );
}
